//Props Validations
import PropTypes from "prop-types";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { styled } from "@mui/material/styles";
// import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}));

function OverlappingScales({ topBoxSelection = "", bottomBoxSelection = "" }) {
    const checkOverlappingScale = (topLabel, bottomLabel) => {
        const topMatch = topLabel.match(/\((\d+)(?:([-&])(\d+))?\)/);
        let topArr = [];
        if (topMatch) {
            const start = parseInt(topMatch[1]);
            let end;
            if (topMatch[2]) {
                end = parseInt(topMatch[3]);
            } else {
                end = start;
            }

            for (let i = start; i >= end; i--) {
                topArr.push(i);
            }
        }
        const bottomMatch = bottomLabel.match(/\((\d+)(?:([-&])(\d+))?\)/);
        let bottomArr = [];
        if (bottomMatch) {
            const start = parseInt(bottomMatch[1]);
            let end;
            if (bottomMatch[2]) {
                end = parseInt(bottomMatch[3]);
            } else {
                end = start;
            }

            for (let i = start; i <= end; i++) {
                bottomArr.push(i);
            }
        }
        const hasCommon = topArr.some((item) => bottomArr.includes(item));

        return hasCommon;
    };
    const renderTooltip = () => {
        if (topBoxSelection && bottomBoxSelection) {
            const isOverlappingScale = checkOverlappingScale(topBoxSelection?.label, bottomBoxSelection?.label);
            if (isOverlappingScale) {
                return (
                    <LightTooltip
                        title="Caution: Overlapping Scales"
                        placement="top-end"
                    >
                        <ErrorOutlineIcon
                            style={{
                                fontWeight: "600",
                                color: "#FF0000",
                                fontSize: "12px",
                                marginRight: "5px",
                            }}
                        />
                    </LightTooltip>
                );
            } else {
                return;
            }
        } else {
            return;
        }
    };

    return <>{renderTooltip()}</>;
}

OverlappingScales.propTypes = {
    topBoxSelection: PropTypes.object,
    bottomBoxSelection: PropTypes.object,
};

export default OverlappingScales;
